import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import appSelectors from '@/redux/app/appSelectors';
import authSelectors from '@/redux/auth/authSelectors';

import { setLanguage } from '@/redux/app/appSlice';

import appOperations from '@/redux/app/appOperations';

import useOutsideClick from '@/hooks/useOutsideClick';

import enImg from '@/images/languages/en.svg';
import ruImg from '@/images/languages/ru.svg';
import esImg from '@/images/languages/es.svg';
import ptImg from '@/images/languages/pt.svg';
import faImg from '@/images/languages/fa.svg';
import hiImg from '@/images/languages/hi.svg';
import arImg from '@/images/languages/ar.svg';

import dropdownImg from '@/images/dropdown.svg';
// import languageImg from '@/images/language.svg';
import LanguageIcon from '@/images/nav_icons/language.svg?react';
import ArrowIcon from '@/images/nav_icons/chevron-right.svg?react';

import s from './btnLang.module.css';

const flag = {
  en: enImg,
  ru: ruImg,
  es: esImg,
  pt: ptImg,
  fa: faImg,
  hi: hiImg,
  ar: arImg,
};

function BtnLang({ onClick = () => {} }) {
  const dispatch = useDispatch();

  const i18n = useSelector(appSelectors.translation);
  const languagesList = useSelector(appSelectors.languagesList);
  const lang = useSelector(appSelectors.language);
  const isAuth = useSelector(authSelectors.isAuthorized);

  const langRef = useRef(null);

  const [displayPopup, setDisplayPopup] = useState(false);
  const togglePopup = () => setDisplayPopup(!displayPopup);

  const setLang = newLang => {
    localStorage.setItem('broker-language', JSON.stringify(newLang));

    dispatch(setLanguage(newLang));

    if (isAuth) appOperations.setLanguage({ language_id: newLang.id });

    setDisplayPopup(false);

    onClick();
  };

  useOutsideClick(langRef, togglePopup, displayPopup);

  const dropdownStyle = displayPopup ? s.dropdown_img_active : s.dropdown_img;
  const popupStyle = displayPopup ? s.popup : s.popup_hidden;
  const listStyle = displayPopup ? s.list : s.list_hidden;

  return isAuth ? (
    <div className={s.lang_wrapper_acc} ref={langRef} data-open={displayPopup}>
      <button type="button" onClick={togglePopup} className={s.btn_lang_acc}>
        <LanguageIcon className={s.icon} />
        <span>{i18n.Language}</span>
        <ArrowIcon className={s.arrow} />
      </button>

      <ul className={listStyle}>
        {languagesList?.length > 0 &&
          languagesList.map(({ id, code, name }) => (
            <li key={id}>
              <button type="button" onClick={() => setLang({ id, code, name })}>
                <img src={flag[code]} alt={name} />
                {name}
              </button>
            </li>
          ))}
      </ul>
    </div>
  ) : (
    <div className={s.lang_wrapper} ref={langRef}>
      <button type="button" onClick={togglePopup} className={s.btn_lang}>
        <img src={flag[lang.code]} alt="lang" className={s.flag_img} />
        <span>{lang.code}</span>
        <img
          src={dropdownImg}
          alt="dropdown"
          className={dropdownStyle}
          height={8}
        />
      </button>

      <ul className={popupStyle}>
        {languagesList?.length > 0 &&
          languagesList.map(({ id, code, name }) => (
            <li key={id}>
              <button type="button" onClick={() => setLang({ id, code, name })}>
                <img src={flag[code]} alt={name} />
                {name}
              </button>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default BtnLang;

BtnLang.propTypes = {
  onClick: PropTypes.func,
};
